import axios from "axios";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useClockStore = defineStore('clock', () => {
    const serverTime = ref<number>(0)


    async function fetchTime() {

        const url = new URL(
            `${import.meta.env.VITE_API_ENDPOINT}/clock`,
            location.href
        )
        return await axios.get(
            url.toString(),
        ).then(
            (res) => {
                return serverTime.value = res.data
            }
        ).catch(
            (req) => {
            }
        )
    }

    return {
        serverTime,
        fetchTime,
    }
});
